// Tiny module-level store for the most recent Evaluate pass-rate, so the
// Dashboard KPI can surface it after the Evaluate tab runs a pass. Module state
// survives tab switches within a page load (cleared on a full reload), matching
// the demo's session model. `null` means no evaluation has run yet.
let lastPassRate = null // fraction 0..1, or null

export function setEvalPassRate(rate) {
  lastPassRate = typeof rate === 'number' ? rate : null
}

export function getEvalPassRate() {
  return lastPassRate
}
